module.exports = __webpack_public_path__ + "static/logo-dd7d4da92ab3258342bc1a091061e990.png";